
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuChavatyTakeoutChavatyTakeoutTopImage } from "@src/constants/images";
import { meta as chavatyPageMeta } from "./chavaty.mdx";
export const meta = {
  path: "/media/harajuku/chavaty_takeout",
  title: "【待ち時間が短い！？】紅茶専門店のチャバティでテイクアウト",
  description: "紅茶専門店チャバティのテイクアウトのおすすめメニューを写真付きでご紹介します。テイクアウトを考えている方の中には、待ち時間を気にされる方も多いのではないかと思うので、行列に関する情報も併せて記載させていただきました。紅茶をベースにした豊富なメニューがテイクアウトできるようになっており、また支払いも電子決済が使えるなど、嬉しいサービスが盛り沢山。ぜひ、チャバティをチェックしてみてください。",
  topImg: harajukuChavatyTakeoutChavatyTakeoutTopImage,
  author: murakamiMasanori,
  tags: ["有名店", "おしゃれな内装", "スイーツ", "人気店", "お店の紹介", "紅茶", "テイクアウト"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`紅茶専門店チャバティのテイクアウトの `}<strong parentName="p">{`おすすめメニューを写真付き`}</strong>{` でご紹介します。`}</p>
    <p>{`紅茶をベースにした豊富なメニューがテイクアウトできるようになっており、他では食べられない `}<strong parentName="p">{`3 種類ソフトクリームや、チャバティ限定のスコーン、ティーラテ`}</strong>{` をご紹介。`}</p>
    <h2>{`チャバティとは`}</h2>
    <InstaImage postId="CCkuawelQA_" mdxType="InstaImage" />
    <p>{`原宿と表参道の中間地点で、まい泉通りの中心にある `}<strong parentName="p">{`紅茶専門店`}</strong>{`です。
`}<strong parentName="p">{`世界的に有名な茶葉`}</strong>{`を確認してから仕入れ、その茶葉でティー、ラテ、スコーン、ソフトクリームなど、いろんな人気メニューを生み出しています。`}</p>
    <p>{`その人気のあまり`}<strong parentName="p">{`連日行列`}</strong>{`ができていることもあるので、まずは気になる行列情報についてご紹介します。`}</p>
    <hr></hr>
    <h2>{`行列情報`}</h2>
    <InstaImage postId="CHdBhfmla0M" mdxType="InstaImage" />
    <p>{`チャバティは特に休日は大行列ができやすいのですが、コロナ以降は原宿や表参道の客足が減ったこともあり、比較的に行列ができづらくなっているのが特徴。`}</p>
    <p>{`コロナ収束してしばらく経つと、`}<strong parentName="p">{`行列が復活する可能性`}</strong>{`があるので注意が必要です。`}</p>
    <h3>{`狙い目の時間帯`}</h3>
    <p>{`平日：行列ができることは少ない
休日：平均 1 時間以上の行列
※特に 12 時〜3 時の時間帯は注意
狙い目はやはり、平日か休日の早めと遅めの時間です！`}</p>
    <hr></hr>
    <h2>{`テイクアウトメニュー`}</h2>
    <p>{`ここからはチャバティのテイクアウトメニューをご紹介します！`}</p>
    <h3>{`ティーソフトクリーム`}</h3>
    <InstaImage postId="B5ygLN1lTXV" mdxType="InstaImage" />
    <p>{`ティーソフトクリームは、3 種類の味から選べるソフトクリーム。`}</p>
    <p>{`チャバティで 1 番人気のメニューで、テイクアウトもできる商品です。`}</p>
    <p>{`見た目の滑らかさだけでなく、食べた瞬間にさらっとした食感が楽しめます。`}</p>
    <h3>{`ボトルティーラテ`}</h3>
    <InstaImage postId="B-bs5I-AU7a" mdxType="InstaImage" />
    <p>{`チャバティの看板メニューであるこちらのメニューは、インスタ映え間違いなしです。
`}<strong parentName="p">{`ウバ、ほうじ茶、抹茶`}</strong>{`の 3 種類からティーを選ぶことができ、濃厚で甘味のある風味が口の中で広がります。`}</p>
    <h3>{`スコーン`}</h3>
    <InstaImage postId="CCjdVTglkNp" mdxType="InstaImage" />
    <p>{`チャバティの定番メニューであるスコーン。
プレーン味や、バターやフルーツを挟んだスコーンなどいろんな種類の味が楽しめるメニューです。その日の気分に合わせてスコーンを選べると嬉しいですよね。`}</p>
    <InstaImage postId="CBqGA6aH4tJ" mdxType="InstaImage" />
    <p>{`テイクアウトでははたくさん注文すれば箱詰めにもしてくれるので、職場、友人、家族にプレゼントしたい方は、たくさん注文してみるのも良いのではないでしょうか。`}</p>
    <h3>{`おわりに`}</h3>
    <p>{`チャバティのテイクアウトメニューを中心に、行列情報も併せてご紹介しましたが、いかがでしたでしょうか。
厳選された茶葉からできるドリンクやフルーツを、テイクアウトだと待ち時間が少なく堪能できるのが特徴になっています。
時間が気になる方や、テイクアウトでどんなおすすめメニューがあるかどうかを、チェックしてチャバティにお越しください。`}</p>
    <ShopInfoBox shopId="bree01a23akg00eoptj0" mdxType="ShopInfoBox" />

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;